import { CardUIExtension, ICardUIExtensionContext, ICardModel } from 'tessa/ui/cards';
import { Guid } from 'tessa/platform';
import { CdUIHelper } from '../CdUIHelper';
import { CdCardTypes } from 'src/cdScripts/Helpers/CdCardTypes';
import { Card } from 'tessa/cards';
import { CdExecutiveSchemeClientHelper } from 'src/cdScripts/Helpers/Cards/CdExecutiveSchemeClientHelper';
import { CdExecutiveDocumentationClientHelper } from 'src/cdScripts/Helpers/Cards/CdExecutiveDocumentationClientHelper';
import { CdGeneralDocumentationClientHelper } from 'src/cdScripts/Helpers/Cards/CdGeneralDocumentationClientHelper';

export class CdExecutiveSchemeUIExtension extends CardUIExtension {

  private _disposer: Function | null = null;

  public async initialized(context: ICardUIExtensionContext) {
    let model: ICardModel;
    let card: Card;
    if ((model = context.model) == null ||
        (card = context.model.card) == null) {
      return;
    }
    if (!Guid.equals(context.model.card.typeId, CdCardTypes.PkExecutiveSchemeTypeID)) {
    return;
    }
    // Таблица "Объект"
    CdUIHelper.InitializeTableObjects(context);
    CdGeneralDocumentationClientHelper.MatchingVisabilityLogic(context);
    CdExecutiveDocumentationClientHelper.FieldLogic(card, model);
    CdGeneralDocumentationClientHelper.ApprovementMatchingRolesChanged(model,'PkExecutiveSchemeMatching','PkExecutiveSchemeRoles');
    CdExecutiveSchemeClientHelper.TableOrderLogic(context);
    CdExecutiveSchemeClientHelper.FieldsObjectsWorksLogic(card, model);
    CdExecutiveSchemeClientHelper.FieldsExecutiveSchemeLogic(card, model, context);
    CdExecutiveSchemeClientHelper.FillApproversLogic(card, model);
  }

  public async saving(context: ICardUIExtensionContext) {
    let card: Card;
    if ((card = context.model.card) == null) {
      return;
    }
    if (!Guid.equals(context.model.card.typeId, CdCardTypes.PkExecutiveSchemeTypeID)) {
      return;
    }     
    await CdExecutiveSchemeClientHelper.CheckApprovementTableOrder(context); //не заменять на context.model.card
    await CdExecutiveSchemeClientHelper.CheckAddedFiles(context, 0);
    if (await !CdGeneralDocumentationClientHelper.CheckEditSignedFile(card)) {
      context.cancel = true;
    }
  }

  public finalized() {
    // подчищаем за собой
    if (this._disposer) {
        this._disposer();
        this._disposer = null;
    }
  }
}